var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.02 91.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffed4a;}.cls-2{fill:#f5c1e7;}.cls-3{fill:#baa1de;}.cls-4{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,32.08S-.35,88,4.66,89.75s55.88,3.59,58,0-.36-57.31-3.22-59.1S1.44,28.5,0,32.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.89,11.84S37.65,51,41,52.25s36.75,2.51,38.16,0S78.88,12.1,77,10.84,38.83,9.33,37.89,11.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.52,31.6c0,7.4-1.24,13.45-4.5,13.45S7.38,39.41,7.38,32,8.76,18.24,12,18.24,16.52,24.2,16.52,31.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.2,82.15c-7.4,0-13.45-1.31-13.43-4.57S55.44,73,62.84,73s13.76,1.45,13.74,4.71S70.6,82.19,63.2,82.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.79,1,80.52,2A4.73,4.73,0,0,1,84.9,6.68L85,21.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.81,41.16s-.22,14.61,2.79,17.19,16.34,1.93,16.34,1.93"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic11);
export default __webpack_public_path__ + "static/media/Pic11.755a46000cddfadbf080788fd7ceb143.svg";
export { ForwardRef as ReactComponent };